import * as React from 'react';
import { memo } from 'react';

const SvgPin2 = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 29 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.6 14.88v8.52h-2.4v-8.52a6 6 0 1 1 2.4 0Zm-4.8 2.709v2.432c-3.52.44-6 1.443-6 2.179 0 .968 4.295 2.4 9.6 2.4s9.6-1.432 9.6-2.4c0-.736-2.48-1.74-6-2.179V17.59c4.867.533 8.4 2.172 8.4 4.611 0 3.008-5.376 4.8-12 4.8s-12-1.792-12-4.8c0-2.439 3.533-4.078 8.4-4.611ZM18 9a3.6 3.6 0 1 1-7.2 0A3.6 3.6 0 0 1 18 9Z", fill: "currentColor" })));
const Memo = memo(SvgPin2);

export { Memo as default };
